/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - Refactor to make it clearer what is the role of this script and move what needs to be moved to formLightboxCtl.js
*/
import LightboxLoader from 'root/main/components/forms/core/lightboxLoader';
import Events from 'root/helpers/events';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

/*
* The `formLightbox.js` is responsible for styling and providing UI functionality for the lightbox, as well as loading the right twig file for the form inside it by using the `/core/lightboxLoader.js` script.
`formLightboxCtl.js` passes the name of the form to `formLightbox.js` after extracting it from the `href` attribute of a clicked button.
* */

/**
 *
 * @param name
 * @param lightbox
 * @constructor
 */
export default function FormSandbox(name, lightbox) {
    this.name = name;
    this.lightbox = lightbox;
    this.element = null;
    this.disclaimerEl = null;
    this.loaded = false;
    this.formType = '';
    this.backgroundColorIdentifier = '__background-color--';
    this.defaultColor = 'dark';
}

FormSandbox.prototype = {
    show() {
        this.element && (this.element.style.display = 'block');
    },

    hide() {
        this.element && (this.element.style.display = 'none');
    },

    isLoaded() {
        return this.loaded;
    },

    load(callback, e) {
        this.getTwigData(data => {
            if (data && typeof data === 'string') {
                data.includes('leadform')
                    ? (this.formType = 'leadform')
                    : (this.formType = 'form');
                this.addFormToPage(data);
                this.initialize();
                callback(e);
                this.loaded = true;
            } else {
                console.log(`error loading lightbox form. data="${data}"`);
                LoggingHandler().logError('User unsuccessfully opened lightbox form', {
                    searchTerm: 'failed-to-load-form-sandbox-lightbox-form',
                    tags: ['forms'],
                    fileName: 'formSandbox.js',
                    additionalData: data,
                });
            }
        });
    },

    getWrapperFormClass() {
        return `js-${this.formType}-lightbox-wrapper`;
    },

    replaceDropdownIcon() {
        const dropdowns = this.element.querySelectorAll('select.gb-form__field-text');
        dropdowns.forEach(dropdown => {
            const icon = `
                    <svg aria-hidden="true" class="js-leadform-form-sandbox__dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect width="24" height="24" fill="white"/>
                        <path d="M15.2651 9.7451L15.312 9.71922L15.3397 9.67339C15.4128 9.55223 15.45 9.42649 15.45 9.27C15.45 9.10521 15.38 8.92575 15.2461 8.81923L12.266 5.85813L12.125 5.71806L11.984 5.85813L8.9949 8.82813L8.99471 8.82793L8.98764 8.83573C8.89107 8.94235 8.8 9.07861 8.8 9.27C8.8 9.41621 8.83268 9.5932 8.96047 9.73427C9.05354 9.83702 9.1853 9.95 9.38044 9.95C9.5239 9.95 9.69299 9.90991 9.82365 9.76856L12.125 7.48194L14.4269 9.76909C14.4783 9.82353 14.5604 9.87229 14.654 9.88611C14.7385 9.92039 14.8176 9.92015 14.862 9.92002C14.8647 9.92001 14.8672 9.92 14.8696 9.92C14.9778 9.92 15.0741 9.86599 15.12 9.84028C15.1233 9.83839 15.1264 9.83665 15.1293 9.8351C15.1679 9.81375 15.1971 9.79226 15.2173 9.77739C15.2179 9.77695 15.2185 9.77651 15.2191 9.77608C15.2396 9.76098 15.2506 9.75311 15.2651 9.7451Z" fill="#191513" stroke="#191513" stroke-width="0.4"/>
                        <path d="M8.98487 14.7549L8.93799 14.7808L8.91032 14.8266C8.83716 14.9478 8.8 15.0735 8.8 15.23C8.8 15.3948 8.87 15.5742 9.00386 15.6808L11.984 18.6419L12.125 18.7819L12.266 18.6419L15.2551 15.6719L15.2553 15.6721L15.2624 15.6643C15.3589 15.5577 15.45 15.4214 15.45 15.23C15.45 15.0838 15.4173 14.9068 15.2895 14.7657L15.1413 14.9L15.2895 14.7657C15.1965 14.663 15.0647 14.55 14.8696 14.55C14.7261 14.55 14.557 14.5901 14.4263 14.7314L12.125 17.0181L9.82312 14.7309C9.7717 14.6765 9.68958 14.6277 9.59602 14.6139C9.51147 14.5796 9.43239 14.5798 9.388 14.58C9.38535 14.58 9.38283 14.58 9.38043 14.58C9.27224 14.58 9.17588 14.634 9.13003 14.6597C9.12665 14.6616 9.12355 14.6634 9.12074 14.6649C9.08207 14.6863 9.05289 14.7077 9.03269 14.7226C9.03209 14.7231 9.03149 14.7235 9.0309 14.7239C9.0104 14.739 8.9994 14.7469 8.98487 14.7549Z" fill="#191513" stroke="#191513" stroke-width="0.4"/>
                    </svg>
                `;

            dropdown.insertAdjacentHTML('afterend', icon);
        });
    },

    getFormBackgroundColor() {
        const formContainer = this.element.firstElementChild;
        if (!formContainer) return this.defaultColor;
        const formClass = formContainer.getAttribute('class');
        if (formClass && formClass.includes(this.backgroundColorIdentifier)) {
            const backgroundColorPattern = new RegExp(
                `(${this.backgroundColorIdentifier})(\\w+)`
            );
            const backgroundColorClass = backgroundColorPattern.exec(formClass);
            if (
                backgroundColorClass &&
                backgroundColorClass.length > 0 &&
                backgroundColorClass[2]
            ) {
                return backgroundColorClass[2];
            }
            return this.defaultColor;
        }
        return this.defaultColor;
    },

    setLightboxBackground() {
        const backgroundClass = `${this.getWrapperFormClass()}${
            this.backgroundColorIdentifier
        }`;
        const wrapperClasses = this.lightbox.getAttribute('class');
        const backgroundColorModifier = this.getFormBackgroundColor();
        if (wrapperClasses.includes(backgroundClass)) {
            const backgroundClassPattern = new RegExp(`(${backgroundClass})(\\w+)`);
            this.lightbox.className = wrapperClasses.replace(
                backgroundClassPattern,
                `$1${backgroundColorModifier}`
            );
        } else {
            this.lightbox.classList.add(`${backgroundClass}${backgroundColorModifier}`);
        }
    },

    addFormToPage(data) {
        if (this.lightbox) {
            this.lightbox.parentElement.classList.add(this.getWrapperFormClass());
            this.lightbox.classList.add('js-leadform-form-sandbox__modal');

            const n = document.createElement('div');
            n.classList.add('js-leadform-form-sandbox__modal__form-content-wrapper');
            n.innerHTML = data;

            this.lightbox.innerHTML = ''; // remove everything inside lightbox wrapper before filling it again
            this.element = this.lightbox.insertBefore(n, this.lightbox.firstChild);
            this.disclaimerEl = this.element.querySelector('.gb-form__disclaimer');
            if (this.element) {
                const fields = this.element.querySelectorAll(
                    '[data-formfield=ls-form-field]'
                );
                if (fields && fields.length > 0) {
                    this.changeFieldID(fields);
                    this.controlRolAnimationClasses(fields);
                }

                this.hideDisclaimerElement();
            }
        }
    },

    controlRolAnimationClasses(fields) {
        let counter = 0;
        Array.from(fields).map(field => {
            counter++;
            field.classList.add(`js-field-${counter}`);
            field.addEventListener('animationend', () => {
                let regex = /js-field-[\d]/;
                let animationClassRemoved = field.className.replace(regex, '');
                field.className = animationClassRemoved;
            });
        });
    },

    changeFieldID(fields) {
        Array.from(fields).map(fieldContainer => {
            const field = fieldContainer.querySelector('input, select, textarea, button');
            const fieldId = field && field.id;
            const label = fieldContainer.querySelector('label');
            const labelFor = label && label.getAttribute('for');
            if (fieldId && labelFor) {
                fieldId && field.setAttribute('id', `${fieldId}_lightbox`);
                label.setAttribute('for', `${fieldId}_lightbox`);
            }
        });
    },

    displayLightboxElsOnSubmit(status) {
        const states = {
            hide: ['add', 'none'],
            show: ['remove', 'block'],
        };
        if (this.lightbox) {
            this.lightbox.classList[states[status][0]]('js-lightbox-wrapper-no-padding');
            const closeBtn = this.lightbox.children[0].classList.contains('js-close-btn')
                ? this.lightbox.children[0]
                : this.lightbox.querySelector('.js-close-btn');
            if (closeBtn) {
                closeBtn.style.display = states[status][1];
            }
        }
    },

    hideDisclaimerElement() {
        if (this.disclaimerEl) {
            this.element.appendChild(this.disclaimerEl);
            this.disclaimerEl.style.display = 'none';
        }
    },

    initialize() {
        Events.addListener('back_to_form', () => {
            this.displayLightboxElsOnSubmit('show');
        });
        Events.addListener('leadform_submit', () => {
            const lightboxCloseBtn = this.lightbox.querySelector(
                '.js-leadform-form-sandbox__modal__close-btn'
            );
            lightboxCloseBtn && (lightboxCloseBtn.style.display = 'none');
            const formSection = this.lightbox.querySelector('[data-form="form-section"]');
            formSection && (formSection.style.opacity = '0');
            this.hideDisclaimerElement();
            this.displayLightboxElsOnSubmit('hide');
        });
        this.replaceDropdownIcon();
    },

    getTwigData(callback) {
        const lightboxLoader = new LightboxLoader(this.name);
        lightboxLoader.onSuccess(callback).onError(callback).getFile();
    },
};
